<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 md10 offset-md1>
        <router-view/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    methods: mapActions('groups', {
      initializeGroups: 'initialize'
    }),
    mounted() {
      this.initializeGroups()
        .catch(this.$defaultHandlerHttp);
    }
  };
</script>

<style scoped>
</style>
